var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oversea"},[(_vm.activtyData.ActivityType==0)?_c('kr-login',{attrs:{"data":_vm.activtyData,"isPC":_vm.isPC}}):_vm._e(),_vm._v(" "),(_vm.activtyData.ActivityType==1)?_c('kr-address',{attrs:{"data":_vm.activtyData,"isPC":_vm.isPC}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67910e37","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/activity/promotions/promotion.vue
// module id = null
// module chunks = 